class BotbCollection extends HTMLElement {
    constructor() {
        super();
        this.buttons = this.querySelectorAll('.collection-page-pill');
        this.checkboxes = this.querySelectorAll('.tag-filter');
        this.handle = this.getAttribute('handle');
        this.currentTags = this.getAttribute('current-tags') ? this.getAttribute('current-tags').split('|') : [];
        this.num_products = this.getAttribute('number-of-items');
        this.tag_selection = this.currentTags;
        this.mobileTagApply = this.querySelectorAll('.mobile-apply-button');
        this.sortSelector = this.querySelector('.botb-collection-toolbar__sort');
        this.currentSort = this.getAttribute('sort-by');
        this.mobileTrigger = this.querySelector('.botb-collection-mobile-trigger');
        this.resetBtn = this.querySelector('.botb-collection-mobile-filters__reset');
        this.productGrid = this.querySelector('.botb-collection-product-grid');
        this.showCurrency = this.getAttribute('show-currency') === 'true' ? true : false;

        function detatch(elem) {
            return elem.parentElement.removeChild(elem);
        }

        function debounce(func){
            var timer;
            return function(event){
                if(timer) clearTimeout(timer);
                timer = setTimeout(func,100,event);
            };
        }

        const this_component = this;
        if(window.innerWidth < 991) {
            this.querySelector('.botb-collection-mobile-bar').appendChild(detatch(this.querySelector('.botb-collection-toolbar__sort')));
            this.querySelectorAll('.dont-show-yet-on-mobile').forEach((el) => { el.style.opacity = 1; el.classList.remove('dont-show-yet-on-mobile'); });
            window.addEventListener("resize",debounce(function(e){
                if(window.innerWidth > 990) this_component.querySelector('.botb-collection-toolbar').appendChild(detatch(this_component.querySelector('.botb-collection-toolbar__sort')));
            }));
        }
        if(window.innerWidth > 990) {
            window.addEventListener("resize",debounce(function(e){
                if(window.innerWidth < 991) this_component.querySelector('.botb-collection-mobile-bar').appendChild(detatch(this_component.querySelector('.botb-collection-toolbar__sort')));
            }));
        }
    }

    connectedCallback() {
        this.buttons.forEach(button => {
            button.addEventListener('click', (evt) => {
                const tag = evt.currentTarget.dataset.tag;
                this.toggleTag(tag);
            });
        });

        this.checkboxes.forEach(checkbox => {
            checkbox.addEventListener('click', (evt) => {
                const tag = evt.currentTarget.value;
                if(evt.currentTarget.closest('.filter-holder').classList.contains('botb-collection-sidebar__block')) {
                    this.toggleTag(tag);
                } else {
                    this.toggleTagInSelection(tag);
                }
            });
        });

        this.mobileTagApply.forEach((button) => {
            button.addEventListener('click', () => {
                this.applyTagSelection();
            });
        });
        

        this.sortSelector.querySelector('label').addEventListener('click', (evt) => {
            if(!this.sortSelector.getAttribute('active')) {
                this.sortSelector.setAttribute('active', '');
            }
        });

        this.querySelector('#sort-by').addEventListener('change', (evt) => {
            this.currentSort = evt.currentTarget.value;
            const tags = (window.innerWidth < 991) ? [...new Set([...this.tag_selection ,...this.currentTags])] : this.currentTags;
            this.updateFilters(tags, evt.currentTarget.value);
        });

        this.mobileTrigger.addEventListener('click', (evt) => {
            if(evt.currentTarget.hasAttribute('disabled')) return;
            this.classList.toggle('open');
        });

        this.resetBtn.addEventListener('click', (evt) => {
            this.tag_selection = [];
            this.updateFilters([]);
        });

        const myInterval = setInterval(myTimer, 500);

        function myTimer() {
            try {
                    document.querySelectorAll('.jdgm-prev-badge__text').forEach((el) => {
                        if(el.innerText == 'No reviews') {
                            el.innerText = '0';
                        }
                    });
                    myStopFunction();
                } catch (error) {}
        }

        function myStopFunction() {
            clearInterval(myInterval);
        }
    }

    toggleTag(tag) {
        console.log('tag:', tag);
        if (this.currentTags.includes(tag)) {
            this.currentTags = this.currentTags.filter(t => t !== tag);
        } else {
            this.currentTags.push(tag);
        }
        this.updateFilters(tag);
    }

    toggleTagInSelection(tag) {
        console.log('tag:', tag);
        if (this.tag_selection.includes(tag)) {
            this.tag_selection = this.tag_selection.filter(t => t !== tag);
        } else {
            this.tag_selection.push(tag);
        }
    }

    applyTagSelection() {
        this.updateFilters('/'+this.tag_selection.join('+'));
    }

    resetFilters() {
        this.classList.add('loading');
        this.setAttribute('disabled', '');
        this.currentTags = [];

        const urlString = `/collections/${this.handle}${this.currentSort ? `?sort_by=${this.currentSort}` : ''}`;
            
        fetch(urlString)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const section = parser.parseFromString(html, 'text/html').querySelector('botb-collection');
                this.replaceWith(section);
            })
            .finally(() => {
                this.classList.remove('loading');
            });
    }
 
    filterListAccordingToRules(groupsAndTags, products) {
        let filteredProducts = products.filter(product => {
            let matchPerGroup = [];
            groupsAndTags.forEach(group => {
                let matchPerTag = [];
                group.tags.forEach(tag => {
                    matchPerTag.push(product.tags.some(tag_inside => tag_inside == tag));
                });
                if(group.operator == 'or' && !matchPerTag.some(match => match)) matchPerGroup.push(true);
                if(group.operator == 'and' && !matchPerTag.every(match => match)) matchPerGroup.push(true);
            });
            return matchPerGroup.every(group => group && group.length > 0 );
        });
        return filteredProducts;
    }

    javascriptReRender(products) {
        console.log(products);
        this.productGrid.innerHTML = '';
        if(products.length > 0) {
            products.forEach(product => {
                this.productGrid.innerHTML += `
                    <botb-product-card handle="${product.handle}" class="botb-product-card " card-style-bordered id="product-card-for-${product.id}">
                        <div class='jdgm-widget jdgm-preview-badge' data-id='${product.id}'>
                            ${product.judgeme_product_badge}
                        </div>
                        <div class="botb-product-card__title ${product.title.length > 22 ? 'long-title' : ''}" ${product.handle == 'beef-live-capsules' ? 'style="max-width: 167px;"' : ''}><a href="/products/${product.handle}" style="text-decoration: none;">${product.title}</a></div>
                        <div class="botb-product-card__image-container" style="background-color: ${product.colour}">
                            <img src="${product.image}" width="218" height="225">
                        </div>
                        ${product.price ? `
                            <div class="botb-product-card__price ${product.compare_at_price ? 'botb-product-card__price--with-comparison' : ''}">
                                <span class="botb-product-card__price--current">
                                    ${product.price}
                                    ${this.showCurrency ? `<span class="currency-code">${product.price_currency}</span>` : ''}
                                </span>
                                ${product.compare_at_price ? `<span class="botb-product-card__price--compare-at">
                                    ${product.compare_at_price}
                                </span>` : ''}
                            </div>
                        `: ''}
                        
                        <product-quick-add variant="${product.variant}" class="botb-button botb-product-card__button">
                            <span class="tick">
                                <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.67286 8.92103L7.0256 9.2698L7.37716 8.91983L15.2975 1.03529L15.3027 1.03013L15.3078 1.02481C15.6441 0.669772 16.0388 0.5 16.5217 0.5C17.0046 0.5 17.3993 0.669771 17.7356 1.02481C18.0866 1.39532 18.2611 1.8074 18.2799 2.27783C18.2974 2.71547 18.1397 3.10607 17.7542 3.47225L17.7541 3.47213L17.7451 3.4812L8.24776 12.9785L8.24763 12.9784L8.23834 12.9882C7.90199 13.3432 7.50729 13.513 7.02441 13.513C6.54153 13.513 6.14683 13.3432 5.81048 12.9882L5.81061 12.988L5.80105 12.9785L1.03449 8.21193L1.03462 8.2118L1.02481 8.2025C0.669772 7.86615 0.5 7.47145 0.5 6.98857C0.5 6.50569 0.669772 6.11099 1.02481 5.77464L0.680938 5.41166L1.02481 5.77464C1.39071 5.428 1.79494 5.26656 2.25785 5.26656C2.71919 5.26656 3.12226 5.42691 3.48718 5.77114L6.67286 8.92103Z" fill="#C5FF54" stroke="#123A0A"></path>
                                </svg>
                            </span>
                            <span class="text">Buy Now</span>
                            <div class="qty-selector" data-variant="${product.variant}">
                                <div class="minus">
                                    <svg width="15" height="4" viewBox="0 0 15 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 1.92285H13.093" stroke="#C5FF54" stroke-width="2.46512" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div class="number">1</div>
                                <div class="plus">
                                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.90625 6.92249H12.9993M7.45276 1.37598V12.469" stroke="#C5FF54" stroke-width="2.46512" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                        </product-quick-add>
                    </botb-product-card>
                `;
            });
        } else {
            this.productGrid.innerHTML = `
                <div class="botb-collection-product-grid__empty">
                    <h2>${emptyStateObj.title}</h2>
                    ${emptyStateObj.linkResetFilters ? `<div class="botb-button" onclick="this.closest('botb-collection').resetFilters();">Reset all filters</div>` : ``}
                    <h3>${emptyStateObj.recommendedProductsTitle}</h3>
                </div>
            `;
            emptyStateObj.recommendedProducts.forEach(product => {
                this.productGrid.innerHTML += `
                    <botb-product-card handle="${product.handle}" class="botb-product-card " card-style-bordered id="product-card-for-${product.id}">
                        <div class='jdgm-widget jdgm-preview-badge' data-id='${product.id}'>
                            ${product.judgeme_product_badge}
                        </div>
                        <div class="botb-product-card__title ${product.title.length > 22 ? 'long-title' : ''}" ${product.handle == 'beef-live-capsules' ? 'style="max-width: 167px;"' : ''}><a href="/products/${product.handle}" style="text-decoration: none;">${product.title}</a></div>
                        <div class="botb-product-card__image-container" style="background-color: ${product.colour}">
                            <img src="${product.image}" width="218" height="225">
                        </div>
                        ${product.price ? `
                            <div class="botb-product-card__price">
                                <span class="botb-product-card__price--current">${product.price}</span>
                                ${product.compare_at_price ? `<span class="botb-product-card__price--compare-at">${product.compare_at_price}</span>` : ''}
                            </div>
                        `: ''}
                        
                        <product-quick-add variant="${product.variant}" class="botb-button botb-product-card__button">
                            <span class="tick">
                                <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.67286 8.92103L7.0256 9.2698L7.37716 8.91983L15.2975 1.03529L15.3027 1.03013L15.3078 1.02481C15.6441 0.669772 16.0388 0.5 16.5217 0.5C17.0046 0.5 17.3993 0.669771 17.7356 1.02481C18.0866 1.39532 18.2611 1.8074 18.2799 2.27783C18.2974 2.71547 18.1397 3.10607 17.7542 3.47225L17.7541 3.47213L17.7451 3.4812L8.24776 12.9785L8.24763 12.9784L8.23834 12.9882C7.90199 13.3432 7.50729 13.513 7.02441 13.513C6.54153 13.513 6.14683 13.3432 5.81048 12.9882L5.81061 12.988L5.80105 12.9785L1.03449 8.21193L1.03462 8.2118L1.02481 8.2025C0.669772 7.86615 0.5 7.47145 0.5 6.98857C0.5 6.50569 0.669772 6.11099 1.02481 5.77464L0.680938 5.41166L1.02481 5.77464C1.39071 5.428 1.79494 5.26656 2.25785 5.26656C2.71919 5.26656 3.12226 5.42691 3.48718 5.77114L6.67286 8.92103Z" fill="#C5FF54" stroke="#123A0A"></path>
                                </svg>
                            </span>
                            <span class="text">Buy Now</span>
                            <div class="qty-selector" data-variant="${product.variant}">
                                <div class="minus">
                                    <svg width="15" height="4" viewBox="0 0 15 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 1.92285H13.093" stroke="#C5FF54" stroke-width="2.46512" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                                <div class="number">1</div>
                                <div class="plus">
                                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.90625 6.92249H12.9993M7.45276 1.37598V12.469" stroke="#C5FF54" stroke-width="2.46512" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                        </product-quick-add>
                    </botb-product-card>
                `;
            });
        }
        this.classList.remove('loading');
        this.removeAttribute('disabled');
    }

    updateFilters(new_tag) {

        console.log(this.currentTags);

        let groups = [...new Set(this.currentTags.map(tag => tag.split('-')[0]))];

        // Group tags
        let groupsAndTags = groups.map(group => {
            return {
                group: group,
                tags: this.currentTags.filter(tag => tag.split('-')[0] === group),
                operator: window.operators[group]
            };
        });

        console.log(groupsAndTags);
        let multiple_tags_in_a_group = groupsAndTags.filter(group => group.tags.length > 1).length;
        let or_operators = groupsAndTags.some(group => group.operator == 'or' && group.tags.length > 1);

        this.classList.add('loading');
        this.setAttribute('disabled', '');

        console.log(multiple_tags_in_a_group);

        if(!multiple_tags_in_a_group || !or_operators) {
            const urlString = `/collections/${this.handle}/${this.currentTags.join('+')}${this.currentSort ? `?sort_by=${this.currentSort}` : ''}`;
            
            fetch(urlString)
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const section = parser.parseFromString(html, 'text/html').querySelector('botb-collection');
                    this.replaceWith(section);
                })
                .finally(() => {
                    this.classList.remove('loading');
                });
        } else {
            const urlString = `/collections/${this.handle}/${this.currentSort ? `?sort_by=${this.currentSort}` : ''}?view=data`;
            fetch(urlString)
                .then(response => response.json())
                .then(json => {
                    console.log(groupsAndTags);
                    console.log(json);
                    this.javascriptReRender(this.filterListAccordingToRules(groupsAndTags, json));
                })
                .finally(() => {
                    
                });
        }
    }
}

customElements.define('botb-collection', BotbCollection);